import { FormComponentFieldTypeEnum } from '@/types/schema';

export const getFieldType = (fieldType: FormComponentFieldTypeEnum) => {
  if (fieldType === FormComponentFieldTypeEnum.Email) {
    return 'email';
  }
  if (fieldType === FormComponentFieldTypeEnum.Password) {
    return 'password';
  }
  return 'text';
};
